import { Controller } from 'stimulus';
import morphDom from 'morphdom';

class AdPositionController extends Controller {
  connect() {
    this.id = this.data.get('id');
    EventManager.onNewEvent('mitre-ad-loaded', ({ adUnit, data }) => {
      if (this.id == adUnit) {
        const parser = new DOMParser();
        // // get existing element
        const prev = this.element;
        // // create the new element
        const fragment = parser.parseFromString(data, 'text/html').body;

        const adUnitDom = morphDom(prev, fragment.firstChild);

        if (adUnitDom.getAttribute('data-controller')) {
          adUnitDom.setAttribute('data-controller', `${adUnitDom.getAttribute('data-controller')} ad-position`)
        } else {
          adUnitDom.setAttribute('data-controller', 'ad-position')
        }
        adUnitDom.setAttribute('data-ad-position-id', this.id)

        if (adUnit[adUnit.length - 1] != 'X') {
          const adContainer = adUnitDom.previousElementSibling;
          if (adContainer) {
            adContainer.style.display = 'none';
          }
        }
      }
    });
  }
}

export default AdPositionController;
